import { createVersionedContext, createVersionedValueMap } from '@backstage/version-bridge';
import React, { useState, useContext, useCallback } from 'react';

const SecretsContext = createVersionedContext("secrets-context");
const SecretsContextProvider = (props) => {
  const { initialSecrets = {} } = props;
  const [secrets, setSecrets] = useState({
    ...initialSecrets
  });
  return /* @__PURE__ */ React.createElement(
    SecretsContext.Provider,
    {
      value: createVersionedValueMap({ 1: { secrets, setSecrets } })
    },
    props.children
  );
};
const useTemplateSecrets = () => {
  var _a;
  const value = (_a = useContext(SecretsContext)) == null ? void 0 : _a.atVersion(1);
  if (!value) {
    throw new Error(
      "useTemplateSecrets must be used within a SecretsContextProvider"
    );
  }
  const { setSecrets: updateSecrets, secrets = {} } = value;
  const setSecrets = useCallback(
    (input) => {
      updateSecrets((currentSecrets) => ({ ...currentSecrets, ...input }));
    },
    [updateSecrets]
  );
  return { setSecrets, secrets };
};

export { SecretsContextProvider, useTemplateSecrets };
//# sourceMappingURL=SecretsContext.esm.js.map
